import { render, staticRenderFns } from "./UsuarioForm.vue?vue&type=template&id=1e996f56&scoped=true&"
import script from "./UsuarioForm.vue?vue&type=script&lang=js&"
export * from "./UsuarioForm.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioForm.vue?vue&type=style&index=0&id=1e996f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e996f56",
  null
  
)

export default component.exports